import { useState, useEffect } from "react";
import classNames from "classnames";

import checkMarkIcon from "/assets/check-mark.svg";

export default function Checkbox({
  children,
  onChange,
  value,
  errors = [],
}) {
  const [isValid, setIsValid] = useState(errors.length == 0);

  useEffect(() => {
    setIsValid(errors.length === 0);
  }, [errors]);

  const handleChange = () => {
    if (typeof onChange === "function")
      onChange(!value);

    setIsValid(true);
  };

  return (
    <div className="inpt-checkbox-wrapper">
      <div
        className="inpt-checkbox-line"
        onClick={handleChange}
      >
        <div className={classNames(
          "inpt-checkbox",
          {
            "inpt-checkbox--checked": !!value,
            "inpt-checkbox--error": !isValid,
          }
        )}>
          <img src={checkMarkIcon} />
        </div>

        <div className="inpt-checkbox-content" onClick={handleChange}>
          {children}
        </div>
      </div>

      <div className="inpt-checkbox-notes">
        {!isValid && errors.map((error, index) => (
          <label key={index} className="lbl lbl--error">{error}</label>
        ))}
      </div>
    </div>
  );
}
